module.exports = __webpack_public_path__ + "img/top1.bae51c71.svg";